import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { RxCross2 } from 'react-icons/rx';
import Button from 'app/components/button';
import Checkbox from 'app/components/checkbox';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { LocalStorage } from 'app/utils/storage';
import { LocalSessionKey } from 'app/constants/app-constants';
import { mallTableHeader } from 'app/constants/table-header-constants';
import useMallManagement from './useMallManagement';
const MallManagement = () => {
  const {
    isdeleteFiltering,
    fetchMallData,
    publishMall,
    publishhistory,
    openModel,
    setOpenModel,
    sectionObj,
    totalNumber,
    filteredData,
    handleDelete,
    handleEdit,
    handleStatusChange,
    inputChangeHandler,
    changeHandler,
    pageLoading,
    currentPage,
    setCurrentPage,
    dataPerPage,
    pageMeta,
    pageCount,
    paginationHandler,
    navigate,
  } = useMallManagement();
  const user = JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));
  const mallTableHeadervalue = mallTableHeader(user?.type);

  const modalContent = useMemo(
    () => (
      <Modal
        size='sm billtest'
        show={openModel}
        aria-labelledby='delete-popup'
        centered
      >
        <div className='modal-container cursor-pointer'>
          <span className='close-icon' onClick={() => setOpenModel(false)}>
            <RxCross2 />
          </span>
        </div>
        <Modal.Body className='text-center d-flex justify-content-around mt-5'>
          <div className='d-flex flex-wrap container_image_form modal-image-form'>
            {publishhistory && (
              <div className='table'>
                <table className='my-table'>
                  <thead>
                    <tr>
                      <th>Module</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {Object.keys(publishhistory).map((key, indx) => (
                      <tr key={indx}>
                        <td>{publishhistory[key]?.title}</td>
                        <td>
                          <Checkbox
                            id={key}
                            checked={publishhistory[key]?.value}
                            disabled={true}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <div className='d-flex justify-content-start'>
              <Button
                className='mt1'
                onClick={publishMall}
                variant='Save'
                name='Submit'
                isDisabled={pageLoading ? true : false}
              />
              <Button
                className='mt1 cancel-button ms-2'
                onClick={() => setOpenModel(false)}
                variant='Cancel'
                name='Cancel'
                isDisabled={pageLoading ? true : false}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    ),
    [openModel, publishhistory]
  );

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          columns={mallTableHeadervalue}
          data={filteredData}
          sectionObj={sectionObj}
          totalNumber={totalNumber}
          fulldata={filteredData}
          fetchData={fetchMallData}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          dataPerPage={dataPerPage}
          pageMeta={pageMeta}
          pageCount={pageCount}
          paginationHandler={paginationHandler}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleStatusChange={handleStatusChange}
          inputChangeHandler={inputChangeHandler}
          changeHandler={changeHandler}
          pageLoading={pageLoading}
          navigate={navigate}
          isdeleteFiltering={isdeleteFiltering}
        />
      </div>
      {modalContent}
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default MallManagement;
